import {Preloader} from "components/Preloader";
import {getEntryPointData} from "modules/actions/entryActions";
import {RequestState} from "modules/enums";
import {getEntryPointState} from "modules/selectors/entryPoint";
import React, {Fragment, useEffect, PropsWithChildren} from "react";
import {useDispatch, useSelector} from "react-redux";

export const HOCEntryPoint: React.FunctionComponent<PropsWithChildren> = ({children}) => {
	const dispatch = useDispatch();
	const entryDataState = useSelector(getEntryPointState);

	useEffect(() => {
		dispatch(getEntryPointData());
	}, [dispatch]);

	if (entryDataState === RequestState.Requested) {
		return <Preloader />;
	}

	return <Fragment>{children}</Fragment>;
};
